import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { MarketingBasicTile } from 'components/marketing-basic-tile';
import { BasicTileImage, BasicTileTitle } from 'components/marketing-basic-tile/styled';

const smallTextLeftAligned = css`
  font-size: 0.875rem;
  line-height: 0.875rem;
  text-align: left;
`;

export const Section = styled.section`
  display: flex;
  flex: 1 1 auto;
  position: relative;
  width: 100%;
  padding: 0 0.75rem;
  margin: 1rem 0 1rem;

  ${Styles.desktop`
    padding: 0;
    margin: 0 auto 1rem;
    max-width: ${Styles.layout.sectionMaxWidth};
    width: calc(100% - 6rem);
  `}
`;

export const LeftContainer = styled.div`
  ${Styles.desktop`
    display: flex;
    flex: 1;
    padding-right: .5rem;
  `}
`;

export const RightContainer = styled.div`
  ${Styles.desktop`
    display: flex;
    flex: 1;
    padding-left: .5rem;
  `}
`;

export const QuadTileContainer = styled.div`
  display: grid;
  grid-gap: 0.5rem;
  grid-template-columns: 1fr 1fr;
  margin: 0 auto;
  ${Styles.desktop`
    max-width: 50rem;
    grid-gap: 1rem;
  `}
`;

export const StyledLink = styled(Link)`
  color: ${Styles.color.black};
`;

export const StyledAnchor = styled.a`
  color: ${Styles.color.black};
`;

export const StyledBasicTile = styled(MarketingBasicTile)`
  background: ${Styles.color.alert.info.text};
  flex-direction: row;
  padding: 1rem;

  ${BasicTileTitle} {
    color: ${Styles.color.alert.info.background};
    ${smallTextLeftAligned}
  }

  p {
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.brand};
    ${smallTextLeftAligned}
  }

  ${BasicTileImage} {
    margin: 0 1rem 0 0;
    max-height: 3.125rem;
    max-width: 3.125rem;
  }
`;
